// export const requestUrl = 'http://127.0.0.1:5000/api/v1'
export const requestUrl = 'http://www.scdnjt.com:4000/api/v1'
// export const requestUrl = 'http://125.71.207.96:5000/api/v1'
// export const requestUrl = 'http://localhost:5000/api/v1'

// export const baseUrl = 'http://localhost:8080'

export const orgId = 65
